import {
  SlTag
} from "./chunk.Q45FKJX7.js";

// src/components/tag/tag.ts
var tag_default = SlTag;
SlTag.define("sl-tag");

export {
  tag_default
};
